export const SNAPTER_HTML_CLASSNAME = 'snapter-html';
export const CLICK_ACTION_TYPE = {
    SET_PARAMS: 'setParams',
    SET_ACTION_PARAMS: 'setActionParams',
    SET_INITIAL_PARAMS: 'setInitialParams',
};
